import lang from '@/lang'
import { projectStates } from '@/modules/base/util/constants'

const { DRAFT, STARTED, FINISHED, PAID } = projectStates

const getStateInfo = (state) => {
  switch (state) {
    case DRAFT:
      return lang.notStarted
    case STARTED:
      return lang.started
    case FINISHED:
      return lang.finished
    case PAID:
      return lang.paid
  }
}

export default getStateInfo
